import { render } from "./CoBrandLinen.vue?vue&type=template&id=7f8787fe&scoped=true"
import script from "./CoBrandLinen.vue?vue&type=script&lang=js"
export * from "./CoBrandLinen.vue?vue&type=script&lang=js"

import "./CoBrandLinen.vue?vue&type=style&index=0&id=7f8787fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8787fe"]])

export default __exports__